<h5 mat-dialog-title class="pb-0">Anatomical equator for the oral surface</h5>
<hr class="p-0 m-0">
<mat-dialog-content class="mat-typography p-1">
    <div class="m-2 p-2">
        <mat-radio-group [(ngModel)]="q1Value">
            <div class="d-flex justify-content-between">
                <div class="text-center">
                    <p>1. Oral very light to no equator, approx. 0.5 mm distance cervical</p><div><img width="auto" height="140" src="b.1.1.svg" /></div>
                    <mat-radio-button value="Oral very light to no equator, approx. 0.5 mm distance cervical"></mat-radio-button>
                </div>
                <div class="text-center">
                    <p>2. Oral light equator, approx. 1.6 mm distance cervical (Standard)</p><div><img width="auto" height="140" src="b.1.2.svg" /></div>
                    <mat-radio-button value="Oral light equator, approx. 1.6 mm distance cervical (Standard)"></mat-radio-button>
                </div>
                <div class="text-center">
                    <p>3. Oral strong equator, approx. 2 mm distance cervical</p><div><img width="auto" height="140" src="b.1.3.svg" /></div>
                    <mat-radio-button value="Oral strong equator, approx. 2 mm distance cervical"></mat-radio-button>
                </div>
                <div class="text-center">
                    <p>4. Oral strong equator, approx. 2.6 mm distance cervical</p><div><img width="auto" height="140" src="b.1.4.svg" /></div>
                    <mat-radio-button value="Oral strong equator, approx. 2.6 mm distance cervical"></mat-radio-button>
                </div>
            </div>
        </mat-radio-group>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [disabled]="!q1Value" (click)="confirm()">OK</button>
    <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>